import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Loader from '../common/loader';
import '../../common/css/noticeList.css';

function NoticeDetail() {
    const [NoticeStatue, setNoticeStatue] = useState('');
    const [Path, setPath] = useState('');
    const [NoticeType, setNoticeType] = useState('');
    // const [fileHref, setFileHref] = useState('');
    const [NoticeIdx, setNoticeIdx] = useState('');
    const [DetailData, setDetailData] = useState(null);
    const [isFetched, setIsFetched] = useState(false);

    const navigate = useNavigate();

    const historyBack = () => {
        const path = window.location.pathname.split('/');
        const basePath = path.slice(0, -1).join('/');

        navigate(basePath);
    };

    const checkNoticeStatus = () => {
        const path = window.location.pathname.split('/')[2];
        setPath(path);

        if (path === 'reservationrules') {
            setNoticeType('rule');
            setNoticeStatue('예약/발권 규정');
        } else if (path === 'reissuerules') {
            setNoticeType('reis');
            setNoticeStatue('재발행 규정');
        } else if (path === 'paidseatsbaggagerules') {
            setNoticeType('bag');
            setNoticeStatue('유료좌석/수하물 규정');
        } else if (path === 'cancelrefund') {
            setNoticeType('cxnl');
            setNoticeStatue('취소/환불 규정');
        } else if (path === 'waivercode') {
            setNoticeType('wvrauth');
            setNoticeStatue('환불 웨이버 코드');
        } else if (path === 'Fueltaxinfo') {
            setNoticeType('tax');
            setNoticeStatue('유류 TAX 정보');
        } else if (path === 'Flightdelayinfo') {
            setNoticeType('note');
            setNoticeStatue('운항 (지연/결항 공문)');
        } else {
            setNoticeType('etc');
            setNoticeStatue('기타');
        }
    };

    useEffect(() => {
        checkNoticeStatus();
        setNoticeIdx(window.location.search.split('=')[1]);
    }, []);

    useEffect(() => {
        if (NoticeType !== '') {
            const getData = async () => {
                try {
                    const hostname = window.location.hostname;
                    let isLocal = null;
                    if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                        isLocal = false;
                    } else {
                        isLocal = true;
                    }

                    const response = await axios.get(
                        `${
                            isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                        }/wpal/board/notice/${NoticeType}/${NoticeIdx}`,
                    );
                    setDetailData(response.data);
                } catch (error) {
                    console.error('Error fetching data:', error);
                } finally {
                    setIsFetched(true);
                }
            };

            if (!isFetched) {
                getData();
            }
        }
    }, [NoticeType, NoticeIdx]);

    // useEffect(() => {
    //     if (DetailData) {
    //         const blobDomain = 'https://prblobstoragedev.blob.core.windows.net';
    //         const isBlob = DetailData.files[0]?.newFileName?.startsWith(blobDomain);
    //         let oldFilePath = '';
    //         if (Path == 'Fueltaxinfo' || Path == 'Flightdelayinfo') {
    //             oldFilePath = `https://hr.raksogroup.com/board/post/file_download_ajax.asp?uploadFileIdx=${DetailData.files[0]?.fileIdx}`;
    //         } else {
    //             oldFilePath = `https://wpal.rakso.co.kr/bbs_download_ajax_wpal.asp?procGubun=F&seq=${NoticeIdx}&uploadFileIdx=${DetailData.files[0]?.fileIdx}`;
    //         }
    //         setFileHref(isBlob ? DetailData.files[0].newFileName : oldFilePath);
    //     }
    // }, [DetailData]);

    return (
        <div id='contents' className='notice-contents'>
            {isFetched ? (
                <>
                    <div class='subp_h_wrap'>
                        <div class='subp_h_list'>
                            <div class='subp_h_home'></div>
                            <div>공지사항</div>
                            <div>규정안내</div>
                            <div>{NoticeStatue}</div>
                        </div>
                    </div>
                    <div class='page_hgroup'>
                        <h2 class='title'>{NoticeStatue}</h2>
                    </div>
                    <div class='event_view'>
                        <div class='view'>
                            <div
                                class='title_wrap'
                                style={{ display: 'flex', justifyContent: 'space-between' }}
                            >
                                <p class='detail-title'>{DetailData.board.postTitle}</p>
                                <p class='period'>{DetailData.board.createDate.split(' ')[0]}</p>
                            </div>
                            <div
                                className='con_wrap ck-content'
                                dangerouslySetInnerHTML={{
                                    __html: DetailData.board.content
                                        .replaceAll(/&quot;/g, '"')
                                        .replaceAll(/&amp;/g, '&')
                                        .replaceAll(/&lt;/g, '<')
                                        .replaceAll(/&gt;/g, '>')
                                        // .replace(/font-family:\s*["']?[^;"']+["']?;?/gi, ''),
                                }}
                            ></div>
                            {DetailData?.files?.map((thisfile, index) => {
                                const blobDomain = 'https://prblobstoragedev.blob.core.windows.net';
                                const isBlob = thisfile?.newFileName?.startsWith(blobDomain);
                                let oldFilePath = '';
                                if (Path === 'Fueltaxinfo' || Path === 'Flightdelayinfo') {
                                    oldFilePath = `https://hr.raksogroup.com/board/post/file_download_ajax.asp?uploadFileIdx=${thisfile?.fileIdx}`;
                                } else {
                                    // oldFilePath = `https://wpal.rakso.co.kr/bbs_download_ajax_wpal.asp?procGubun=F&seq=${NoticeIdx}&uploadFileIdx=${thisfile?.fileIdx}`;
                                    oldFilePath = `https://wpal.onfill.com/bbs_download_ajax_wpal.asp?procGubun=F&seq=${NoticeIdx}&uploadFileIdx=${thisfile?.fileIdx}`;
                                }
                                const fileHref = isBlob ? thisfile?.newFileName : oldFilePath;

                                return (
                                    <div class='download_wrap'>
                                        <a href={fileHref}>
                                            <span>{thisfile.fileName}</span>
                                        </a>
                                    </div>  
                                );
                                    
                            })}

                            <div class='other_writing_wrap'>
                                {!DetailData.prevBoard ? (
                                    ''
                                ) : (
                                    <Link
                                        className='prev'
                                        to={`/notice/${Path}/detail?idx=${DetailData.prevBoard.postIdx}`}
                                        onClick={() =>
                                            (window.location.href = `/notice/${Path}/detail?idx=${DetailData.prevBoard.postIdx}`)
                                        }
                                    >
                                        <span>이전글</span>
                                        <span className='wpal-limited-text'>
                                            {DetailData.prevBoard.postTitle}
                                        </span>
                                    </Link>
                                )}
                                {!DetailData.nextBoard ? (
                                    ''
                                ) : (
                                    <Link
                                        className='next'
                                        to={`/notice/${Path}/detail?idx=${DetailData.nextBoard.postIdx}`}
                                        onClick={() =>
                                            (window.location.href = `/notice/${Path}/detail?idx=${DetailData.nextBoard.postIdx}`)
                                        }
                                    >
                                        <span className='wpal-limited-text'>
                                            {DetailData.nextBoard.postTitle}
                                        </span>
                                        <span>다음글</span>
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                    <div class='btn_wrap mt30'>
                        <a class='btn36 gray list' style={{ width: '130px' }} onClick={historyBack}>
                            목록보기
                        </a>
                    </div>
                </>
            ) : (
                <Loader></Loader>
            )}
        </div>
    );
}

export default NoticeDetail;
